import React, { useEffect } from 'react';

import Text from 'ui/Text';
import Button from 'ui/Button';
import ViewSpinner from 'components/ViewSpinner';

import { formatDenmarkCurrency } from 'utils/UiHelper';
import { NotificationManager } from 'react-notifications';
import dropdownModal from 'features/SpilKlub/HOCs/dropdownModal';

import useOffersData from '../state/useOffersData';
import useBuyCoupon from '../state/useBuyCoupon';

import successIcon from 'images/success_icon.svg';
import '../styles/payment-confirm.css';
import useHistoryItemsCount from 'features/BottomNavigation/useHistoryItemsCount';

const BetConfirm = ({
    isOpen = false,
    onClose = () => {},
    onSuccess = () => {},
    coupon,
    pool,
    refetchPoolDetails,
}) => {
    const { combinationPrice, combinationCount, selections, couponId } = coupon;

    const { extId } = useOffersData();
    const { refetch: refetchHistoryItemsCount } = useHistoryItemsCount();

    const { buyCoupon, status, error, isError, reset } = useBuyCoupon({
        extId,
        poolId: pool.poolId,
        couponId,
        combinationPrice,
        combinationCount,
        selections,
    });

    const poolLeftOverAmount = pool?.payout?.poolLeftOverAmount;
    const betPrice = combinationCount * combinationPrice;
    const leftOverAfterBet = poolLeftOverAmount - betPrice;

    const buyCouponHandler = () => {
        status !== 'success' &&
            buyCoupon()
                .then(refetchHistoryItemsCount)
                .then(refetchPoolDetails)
                .finally(onClose);
    };

    const groupName = pool?.poolTemplate?.name;

    useEffect(() => {
        refetchPoolDetails();
    }, []);

    useEffect(
        () => {
            if (isError) {
                NotificationManager.error(error);
            }
        },
        [isError]
    );

    useEffect(
        () => {
            if (!isOpen) {
                reset();
                onClose();
            }
        },
        [isOpen]
    );

    useEffect(
        () => {
            if (status === 'success') {
                setTimeout(() => {
                    onSuccess();
                }, 1000);
            }
        },
        [status]
    );

    return (
        <>
            <hr size={1} color={'#DADDE4'} />
            <div className="left-indent-sm top-indent-lg bottom-indent-lg">
                <Text
                    size={'x15'}
                    color={'#333'}
                    margin={'0 0 5px'}
                    padding={'0'}
                >
                    Big 9 - {groupName}
                </Text>
                <Text
                    size={'x15'}
                    bold
                    color={'#18AA1B'}
                    margin={'0'}
                    padding={'0'}
                >
                    Andels pulje efter køb:{' '}
                    {formatDenmarkCurrency(leftOverAfterBet)} kr.
                </Text>
            </div>
            <hr size={1} color={'#DADDE4'} />
            <Button
                active={status !== 'success'}
                green={status === 'success'}
                width={'calc(100% - 18px)'}
                margin={'27px auto 0'}
                justify={
                    status !== 'loading' && status !== 'success'
                        ? 'space-between'
                        : 'center'
                }
                padding={'15px 40px'}
                fontSize={'16px'}
                onClick={buyCouponHandler}
            >
                {status === 'loading' ? (
                    <ViewSpinner
                        style={{
                            padding: 0,
                            fontSize: 9,
                        }}
                    />
                ) : status === 'success' ? (
                    <>
                        <span style={{ marginRight: 7 }}>Andele købt</span>
                        <img src={successIcon} alt="success" />
                    </>
                ) : (
                    <>
                        <span>Køb kupon</span>
                        <span>{formatDenmarkCurrency(betPrice)} kr.</span>
                    </>
                )}
            </Button>
        </>
    );
};

export default dropdownModal(BetConfirm);
